import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';
import { Fragment, useMemo } from 'react';

export const RowsError = ({
  message,
  ranges,
  onRangeClick,
}: {
  message: string;
  ranges: number[][];
  onRangeClick: (rowIndex: number) => void;
}) => {
  const normalisedRanges = useMemo(
    () =>
      ranges.reduce<[number, string][]>((a, b) => {
        const first = b[0];
        const last = b[b.length - 1];
        const value = first === last ? `${first}` : `${first}-${last}`;
        return [...a, [b[0], value]];
      }, []),
    [ranges]
  );

  return (
    <div className="grid grid-cols-[24px_max-content] items-center gap-x0_5">
      <svg width="24" height="24" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="6" fill="#FFF" />
        <WarningSolid className="fill-warning" />
      </svg>
      <span className="text-xs text-solid">
        {`${message}: `}
        {normalisedRanges.map((n, i) => (
          <Fragment key={`row-error-${i}`}>
            {i === 0 ? `` : `, `}
            <button onClick={() => onRangeClick(n[0])}>
              <span className="underline">{n[1]}</span>
            </button>
          </Fragment>
        ))}
      </span>
    </div>
  );
};
